function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4092D7",
  d: "M8.89949494,8.89949494 L8.89949494,3.89949494 C8.89949494,3.34721019 9.34721019,2.89949494 9.89949494,2.89949494 C10.4517797,2.89949494 10.8994949,3.34721019 10.8994949,3.89949494 L10.8994949,8.89949494 L15.8994949,8.89949494 C16.4517797,8.89949494 16.8994949,9.34721019 16.8994949,9.89949494 C16.8994949,10.4517797 16.4517797,10.8994949 15.8994949,10.8994949 L10.8994949,10.8994949 L10.8994949,15.8994949 C10.8994949,16.4517797 10.4517797,16.8994949 9.89949494,16.8994949 C9.34721019,16.8994949 8.89949494,16.4517797 8.89949494,15.8994949 L8.89949494,10.8994949 L3.89949494,10.8994949 C3.34721019,10.8994949 2.89949494,10.4517797 2.89949494,9.89949494 C2.89949494,9.34721019 3.34721019,8.89949494 3.89949494,8.89949494 L8.89949494,8.89949494 Z",
  transform: "rotate(45 9.9 9.9)"
});

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.d28586ef.svg";
export { ForwardRef as ReactComponent };